import { Typography } from "@mui/material";
import SearchableSelect, {
  SelectOption,
} from "app/components/SearchableSelect";
import React from "react";
import { useTranslation } from "react-i18next";
import { ALL_RELIGIONS } from "utils/constants";
import { useStyles } from "./styles";

interface TProps {
  value: string;
  disabled?: boolean;
  onChange(e): void;
  label: string;
}
const ReligionField = (props: TProps) => {
  const styles = useStyles();
  const { t } = useTranslation();

  const options: SelectOption[] = ALL_RELIGIONS.map((r) => {
    const value =
      r?.split(".")[r?.split(".")?.length - 1]?.toLowerCase() ?? "";
    return { label: t(r), value };
  });

  return (
    <>
      <Typography noWrap className={styles.label}>
        {props.label}
      </Typography>
      <SearchableSelect
        options={options}
        value={props.value ?? ""}
        onChange={(val) =>
          props.onChange({
            target: { name: "religion", value: String(val) },
          })
        }
        disabled={props.disabled}
        placeholder={t("PATIENTS.OPTIONS.CHOOSE_RELIGION") as string}
        name="religion"
        className={styles.textEnabledSelect}
      />
    </>
  );
};
export default ReligionField;
